var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-modal',{attrs:{"fullscreen":_vm.fullscreen,"transparent":"","close-class-list":_vm.closeClassList},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}},[_c('div',{ref:"content",staticClass:"premium-modal__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }